<template>
<div v-if="isShow && memoDetail">
    <div class="txt-area">
        <p class="b">カテゴリー</p>
    </div>
    <div class="real-select">
        <select v-model="categoryId">
            <option :value="null" disabled hidden>選択してください</option>
            <option v-for="(item, index) in categories" :value="index" :key="item">{{ item }}</option>
        </select>
    </div>
    <div class="txt-area">
        <p class="b">メモ</p>
        <textarea v-model="content" class="self-introduction1" placeholder="お相手の情報をメモしよう" :maxlength="maxLength">
お相手情報をメモしよう
</textarea>
        <div class="clearfix">

            <div class="self-introduction3">{{lengthContent}}/{{maxLength}}</div>
        </div>

        <p>※メモの内容はお相手には見えません。</p>
        <p>※メモはいつでも編集・削除ができます。</p>

    </div>
    <div class="btn9"><a @click="$emit('submit', {
        categoryId: categoryId,
        content: content,
        memoId: memoDetail.memo_id,
        userId: memoDetail.id
    })">保存</a></div>
    <div class="btn8"><a @click="$emit('delete', {
        userId: memoDetail.id,
        memoId: memoDetail.memo_id
    })">削除</a></div>
</div>
</template>

<script>
export default {
    props: {
        isShow: Boolean,
        memoDetail: Object
    },
    data: () => ({
        content: '',
        categoryId: null,
        maxLength: 500
    }),
    computed: {        
        categories() {
            const categories = {...this.$store.getters.metadata.memo_category}
            delete categories[1]; 

            return categories
        },
        lengthContent() {
            if (this.content)
                return this.content.length
                
            return 0
        }
    },
    mounted() {
        if (this.isShow) {
            this.content = this.memoDetail.content;
            this.categoryId = parseInt(this.memoDetail.category);

        }
    },
    methods: {}
}
</script>

<style scoped>
.real-select select {
    margin: 3%;
    width: 94%;
}
</style>
